import {
  Package, Mail, FileText, AlertTriangle, ChevronRight, ArrowRight,
} from "lucide-react";

const KPI_CONFIG = [
  {
    key: "pacchiDaOrdinare",
    icon: Package,
    iconBg: "bg-red-500",
    valueColor: "text-red-600",
    footerBg: "bg-red-50",
    linkColor: "text-red-600 hover:text-red-700",
    label: "Pacchi da ordinare",
    sub: "per il mese corrente",
    action: "Vai agli ordini",
    tab: "magazzino",
  },
  {
    key: "reminderDaInviare",
    icon: Mail,
    iconBg: "bg-orange-500",
    valueColor: "text-orange-600",
    footerBg: "bg-orange-50",
    linkColor: "text-orange-600 hover:text-orange-700",
    label: "Reminder da inviare",
    sub: "ai familiari",
    action: "Vai ai reminder",
    tab: "magazzino",
  },
  {
    key: "reportDaInviare",
    icon: FileText,
    iconBg: "bg-blue-500",
    valueColor: "text-blue-600",
    footerBg: "bg-blue-50",
    linkColor: "text-blue-600 hover:text-blue-700",
    label: "Report da inviare",
    sub: "ai familiari",
    action: "Vai ai report",
    tab: "report",
  },
  {
    key: "fornitureAslInScadenza",
    icon: AlertTriangle,
    iconBg: "bg-amber-500",
    valueColor: "text-amber-600",
    footerBg: "bg-amber-50",
    linkColor: "text-amber-600 hover:text-amber-700",
    label: "Forniture ASL in scadenza",
    sub: "entro 30 giorni",
    action: "Vai alle scadenze",
    tab: "magazzino",
  },
];

export default function PrimaNotaKpiBar({ kpi, onNavigate }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 mb-4">
      {KPI_CONFIG.map((cfg) => {
        const Icon = cfg.icon;
        const value = kpi[cfg.key] ?? 0;
        return (
          <div
            key={cfg.key}
            role="button"
            tabIndex={0}
            onClick={() => onNavigate?.(cfg.tab)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onNavigate?.(cfg.tab);
              }
            }}
            className="bg-white rounded-xl border border-slate-200/80 shadow-sm overflow-hidden cursor-pointer hover:shadow-md transition-shadow flex flex-col"
          >
            <div className="p-4 pb-3 flex-1">
              <div className="flex items-start justify-between gap-3">
                <div
                  className={`w-11 h-11 rounded-lg ${cfg.iconBg} flex items-center justify-center shrink-0 shadow-sm`}
                >
                  <Icon className="w-5 h-5 text-white" strokeWidth={2} />
                </div>
                <div className={`flex items-center gap-0.5 ${cfg.valueColor}`}>
                  <span className="text-3xl font-bold leading-none tabular-nums">
                    {value}
                  </span>
                  <ChevronRight className="w-4 h-4 text-slate-300 shrink-0 mt-0.5" />
                </div>
              </div>
              <h3 className="mt-3 text-base font-bold text-slate-900 leading-snug">
                {cfg.label}
              </h3>
              <p className="text-sm text-slate-500 mt-0.5">{cfg.sub}</p>
            </div>
            <div className={`${cfg.footerBg} px-4 py-2.5 border-t border-slate-100/80`}>
              <button
                type="button"
                className={`text-sm font-medium inline-flex items-center gap-1.5 ${cfg.linkColor}`}
                onClick={(e) => {
                  e.stopPropagation();
                  onNavigate?.(cfg.tab);
                }}
              >
                {cfg.action}
                <ArrowRight className="w-3.5 h-3.5" />
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
